<!-- 新增活动 -->
<template>
   <div class='addActivity'>
      <div class="left">
         <div style="border-bottom: 1px solid rgba(192, 195, 202, 1);margin-bottom: 0.23rem;">
            <div class="title">
               创建活动<span>-旅游基金限时领！</span>
            </div>
            <div class="lineBox1">
               <p class="p1">活动ID<span>*</span></p>
               <el-input style="width: 2.5rem; margin-right: 0.1rem" size="small" v-model="input"
                  placeholder="请输入活动ID "></el-input>
            </div>
            <div class="lineBox1">
               <p class="p1">活动名称<span>*</span></p>
               <el-input style="width: 2.5rem; margin-right: 0.1rem" size="small" v-model="input"
                  placeholder="请输入活动名称"></el-input>
            </div>
            <div class="lineBox1">
               <p class="p1">活动发起方<span>*</span></p>
               <el-input style="width: 2.5rem; margin-right: 0.1rem" size="small" v-model="input"
                  placeholder="请输入活动发起方 "></el-input>
            </div>
            <div class="lineBox1" style="margin-bottom: 0.4rem;">
               <p class="p1">活动时间段<span>*</span></p>
               <el-date-picker style="margin-right: 0.1rem" size="small" v-model="input" type="daterange"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
               </el-date-picker>
            </div>
            <div class="lineBox1" style="align-items: flex-start;">
               <p class="p1">活动平台<span>*</span></p>
               <div>
                  <div>
                     <el-radio v-model="radio" label="1">C端</el-radio>
                     <el-checkbox-group v-model="checkList">
                        <el-checkbox label="小程序"></el-checkbox>
                        <el-checkbox label="App"></el-checkbox>
                     </el-checkbox-group>
                  </div>
                  <div>
                     <el-radio v-model="radio" label="2">B端</el-radio>
                  </div>
               </div>
            </div>
            <el-card class="box-card">
               <div style="margin-bottom: 0.2rem;">
                  <el-radio v-model="radio1" label="1">所有B端渠道用户（指定用户总数：0）</el-radio>
               </div>
               <div style="margin-bottom: 0.2rem;">
                  <el-radio v-model="radio1" label="2">部分B端渠道用户（指定用户总数：10）</el-radio>
               </div>
               <div class="lineBox2">
                  <p>按客户类型</p>
                  <div class="line"></div>
                  <el-checkbox-group v-model="checkList1">
                     <el-checkbox label="抢单达人"></el-checkbox>
                     <el-checkbox label="方案达人"></el-checkbox>
                     <el-checkbox label="订单达人"></el-checkbox>
                     <el-checkbox label="拓客达人"></el-checkbox>
                  </el-checkbox-group>
               </div>
               <div class="lineBox2" style="align-items: flex-start;">
                  <p>按客户地域</p>
                  <div class="line"></div>
                  <div style="display: flex;flex-direction: column;">
                     <div style="display: flex;align-items: center;margin-bottom: 0.15rem;" v-for="(item, index) in 2"
                        :key="index">
                        <div style="margin-right: 0.2rem;">
                           <cityAutocomplete :searchType="2"></cityAutocomplete>
                        </div>
                        <div style="margin-right: 0.2rem;">
                           <cityAutocomplete></cityAutocomplete>
                        </div>
                        <i v-if="index == 0" style="font-size: 0.25rem;cursor: pointer;" class="el-icon-plus"></i>
                        <i v-else style="font-size: 0.25rem;cursor: pointer;" class="el-icon-minus"></i>
                     </div>
                  </div>
               </div>
               <div class="lineBox2">
                  <p>按用户沉寂时间指定</p>
                  <div class="line"></div>
                  <span style="margin-right: 0.2rem;">设定</span>
                  <el-input style="width: 2rem; margin-right: 0.1rem" size="small" v-model="input"
                     placeholder="数字"></el-input>
                  <span>天内未登录</span>
               </div>
               <div class="lineBox2">
                  <el-radio v-model="radio1" label="2">指定B端渠道用户</el-radio>
                  <div class="line"></div>
                  <el-input style="width: 2rem; margin-right: 0.1rem" size="small" v-model="input"
                     placeholder="请选择用户"></el-input>
               </div>
            </el-card>
            <div class="lineBox1" style="flex-direction: column;align-items: flex-start;margin-bottom: 0.4rem;">
               <p style="width: 1.7rem;" class="p1">活动规则介绍（举例）<span>*</span></p>
               <img :src="require('@/assets/png/liucheng.png')" alt="">
            </div>
            <div class="lineBox1">
               <p style="width: 1.7rem;margin-bottom: 0.2rem;" class="p1">优惠卷设置<span>*</span></p>
            </div>
            <div class="lineBox3">
               <p style="width: 1rem;">
                  <span style="color: red;">*</span>主劵：
               </p>
               <div>
                  <p style="color: red;margin-bottom: 0.1rem;">1.主券的优患力度高于子券，更利于活动裂变传播 2.裂变优患券为普通优惠券</p>
                  <el-card class="box-card1">
                     <div class="lineBox4">
                        <p>订单满:</p>
                        <el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>
                        <p>元</p>，
                        减<el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>元
                     </div>
                     <div class="lineBox4">
                        <p>有效期:领取后</p>
                        <el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>
                        <p style="margin-right: 0.1rem;">日内有效，逾期失效</p>
                        <i style="transform: rotate(-90deg);color: #65A1F8;cursor: pointer;" class="el-icon-sort"></i>
                     </div>
                     <div class="lineBox4">
                        <p>发放数量:</p>
                        <el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>
                        <p style="margin-right: 0.1rem;">人</p>
                        <p style="color: #DED8D5;">建议数量尽可能多</p>
                     </div>
                     <div class="lineBox4" style="margin-bottom: 0;">
                        <p>获得条件: 领券好友数达</p>
                        <el-input type="number" style="margin:0 0.1rem;width: 0.8rem;" size="small"
                           v-model="input"></el-input>
                        <p>人</p>
                     </div>
                  </el-card>
               </div>
            </div>
            <div class="lineBox3" style="margin-bottom: 0.2rem;">
               <p style="width: 1rem;">
                  <span style="color: red;">*</span>子劵：
               </p>
               <div>
                  <el-card class="box-card1">
                     <div class="lineBox4">
                        <p>订单满:</p>
                        <el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>
                        <p>元</p>，
                        减<el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>元
                     </div>
                     <div class="lineBox4">
                        <p>有效期:领取后</p>
                        <el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>
                        <p style="margin-right: 0.1rem;">日内有效，逾期失效</p>
                        <i style="transform: rotate(-90deg);color: #65A1F8;cursor: pointer;" class="el-icon-sort"></i>
                     </div>
                     <div class="lineBox4">
                        <p>发放数量:</p>
                        <el-input-number style="margin:  0 0.1rem;" size="small"></el-input-number>
                        <p style="margin-right: 0.1rem;">人</p>
                        <p style="color: #DED8D5;">建议数量尽可能多</p>
                     </div>
                     <div class="lineBox4" style="margin-bottom: 0;">
                        发放数量：300
                     </div>
                  </el-card>
               </div>
            </div>
            <div class="lineBox3">
               <p style="width: 1rem;">
               </p>
               <div>
                  <el-card style="background-color: #F8F8F8;justify-content: flex-start;" class="box-card1">
                     <p>预计总费用: 2000元</p>
                     <p>主券:500元</p>
                     <p>子券:1500元</p>
                  </el-card>
               </div>
            </div>
            <div class="lineBox1">
               <p class="p1">预警邮箱<span>*</span></p>
               <el-input style="width: 2.5rem; margin-right: 0.1rem" size="small" v-model="input"></el-input>
            </div>
            <div class="lineBox1">
               <p class="p1">使用范围</p>
               <el-radio @change="selectGoodsChange" v-model="radio" label="1">本公司的所有商品</el-radio>
               <el-radio @change="selectGoodsChange"  v-model="radio" label="2">指定商品 已选线路 <span style="color: #DB4E1A;">3</span>条 <el-button
                     size="mini">选择方案</el-button> </el-radio>
            </div>
            <div class="lineBox1">
               <p class="p1">展示效果</p>
               小程序及www.dijie360.com 的企业介绍页面 (展现形式参照右侧样例)
            </div>
            <div class="lineBox1">
               <p class="p1">发放方式</p>
               客户行为触发 (点击或扫二维码)
            </div>
            <div class="lineBox1" style="align-items: flex-start;margin-bottom: 0.5rem;">
               <p class="p1">选择平台活动推广方式</p>
               <el-checkbox-group style="margin: 0 !important;" v-model="checkList">
                  <el-checkbox>
                     <p style="color: #000;margin-bottom: 0.16rem;">手机短信通知 （ <span style="color: #8D959F;">收费标准0.06元/条
                           您目前短信储值为 0 <span style="color: #DB4E1A;">充值</span> ）</span></p>
                     <div style="color: #6B7785;display: flex;">
                        <span style="margin-right: 0.1rem;"> 短信编辑：</span>
                        <el-input style="width: 5rem;" type="textarea"
                           placeholder="XXX（这里带入用户企业名称）给您送现金券啦！赶紧点击去看看吧~  http://a.app.qq.com/oupons.yyb" show-word-limit>
                        </el-input>
                     </div>
                  </el-checkbox>
                  <el-checkbox>
                     <p style="color: #000;margin-bottom: 0.16rem;">系统Push消息</p>
                     <div style="color: #6B7785;display: flex;">
                        <span style="margin-right: 0.1rem;"> 消息编辑：</span>
                        <el-input style="width: 5rem;" type="textarea"
                           placeholder="地接360给您送现金券啦！同业下单小能手下单专享，赶紧点击去看看吧~[点击查看]http://a.app.qq.com/oupons.yybhttp://a.app.qq.com/oupons.yyb"
                           show-word-limit>
                        </el-input>
                     </div>
                  </el-checkbox>
               </el-checkbox-group>
            </div>
            <div style="display: flex;align-items: center;justify-content: center;margin-bottom: 0.42rem;">
               <el-button style="width: 1rem;" type="primary">已提交</el-button>
               <el-button style="width: 1rem;">取消</el-button>
            </div>
         </div>
         <div class="lineBox5">
            <p class="p1">活动提交后您还可以自己以下方方式推广，效果最佳哦~ <span>(推荐!!!)</span> 提交前下方信息仅为样例参考 非本次活动！</p>
            <el-card class="box-card3">
               <div class="div2">
                  <p class="p2">社交网络邀请</p>
                  <el-input style="width: 5rem;" placeholder="请输入内容">
                     <template slot="append">
                        <el-button style="background-color: #398187;color: #fff;">复制链接</el-button>
                        <el-button style="background-color: #CD3734;color: #fff;" icon="el-icon-search">微博</el-button>
                     </template>
                  </el-input>
               </div>
               <div class="div2" style="align-items: flex-start;margin-bottom: 0.3rem;">
                  <p class="p2">微信邀请</p>
                  <div class="div3">
                     <div class="div3T">
                        <span>第一步：微信扫描二维码</span>
                        <span>第二步：点击...分享页面</span>
                     </div>
                     <img :src="require('@/assets/png/QRcode.png')" alt="">
                  </div>
               </div>
               <div class="div2">
                  <p class="p2">邮箱邀请</p>
                  <el-input style="width: 5rem;" placeholder="请输入电子邮箱">
                     <template slot="append">
                        <el-button style="background-color: #CD3634;color: #fff;">发送邀请</el-button>
                     </template>
                  </el-input>
               </div>
            </el-card>
         </div>
      </div>
      <div class="right">
         <div class="rightTop">
            <div class="div1">
               <span>效果样例</span>
               <p>可点击图片查看放大效果</p>
            </div>
            <div class="div2">
               <el-radio v-model="radio3" label="1">WWW.DIJIE360.COM</el-radio>
               <el-radio v-model="radio3" label="2">小程序</el-radio>
            </div>
         </div>
         <div style="display: flex;justify-content: center;">
           <img class="imgs" :src="viewImgs[radio3]">
         </div>
      </div>
      <AddActivityGoods ref="AddActivityGoods"></AddActivityGoods>
   </div>
</template>

<script>
import cityAutocomplete from '@/views/common/cityAutocomplete.vue'
import AddActivityGoods from './AddActivityGoods.vue';
export default {
   components: {
      cityAutocomplete,
      AddActivityGoods
   },
   data() {
      return {
         input: '',
         radio: '',
         radio1: '',
         radio3:'1',
         checkList: [],
         checkList1: [],
         viewImgs:{
            '1':require('@/assets/png/webImg.png'),
            '2':require('@/assets/png/wxXcx.png'),
         }
      }
   },
   computed: {},
   watch: {},
   methods: {
      //选择商品
      selectGoodsChange() {
         this.$refs.AddActivityGoods.init()
      }
   },
   created() {

   },
   mounted() {

   },
}
</script>
<style lang='scss' scoped>
/deep/ .lineBox2 .el-radio {
   margin-right: 0 !important;
}

/deep/ .lineBox1 .el-checkbox {
   display: flex;
}

/deep/ .lineBox1 .el-checkbox-group {
   display: flex;
   flex-direction: column;
   padding-left: 0.35rem;
   margin: 0.2rem 0;

   .el-checkbox {
      margin-bottom: 0.2rem;

      &:nth-last-child(1) {
         margin-bottom: 0;
      }
   }
}

.addActivity {
   background-color: #fff;
   padding: 0.3rem 0;
   display: flex;
   .left {
      width: 55%;
      padding: 0 0.4rem;

      .title {
         left: 315px;
         color: rgba(16, 16, 16, 1);
         font-size: 0.2rem;
         font-family: SourceHanSansSC-regular;
         margin-bottom: 0.3rem;

         span {
            font-size: 0.16rem;
            font-weight: bold;
         }
      }

      .lineBox1 {
         display: flex;
         align-items: center;
         margin-bottom: 0.2rem;

         .p1 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.16rem;
            font-family: SourceHanSansSC-regular;
            width: 1.2rem;

            span {
               color: red;
            }
         }

         .div1 {
            span {
               color: red;
            }
         }
      }

      .lineBox3 {
         display: flex;
         padding-left: 0.5rem;
         margin-bottom: 0.2rem;
      }

      .lineBox4 {
         .p1 {
            color: #000;
            font-size: 0.16rem;
            font-family: SourceHanSansSC-regular;
            margin-bottom: 0.14rem;

            span {
               color: red;
            }
         }
      }

      .box-card {
         margin-bottom: 0.4rem;

         .lineBox2 {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;

            p {
               width: 1.4rem;
               text-align: right;
            }

            .line {
               height: 0.3rem;
               border-right: 1px solid #CCCCCC;
               width: 1px;
               margin: 0 0.2rem;
            }
         }
      }

      .box-card1 {
         width: 7rem;
         display: flex;
         justify-content: center;
         align-items: center;

         .lineBox4 {
            display: flex;
            align-items: center;
            margin-bottom: 0.15rem;
         }
      }

      .lineBox5 {
         .p1 {
            color: #000;
            font-size: 0.16rem;
            font-family: SourceHanSansSC-regular;
            text-align: left;
            margin-bottom: 0.14rem;
            span {
               color: red;
            }
         }
         .p2 {
            width: 1.2rem;
            color: #000;
            font-size: 0.16rem;
            font-family: SourceHanSansSC-regular;
            text-align: left;
         }

         .div2 {
            display: flex;
            align-items: center;
            margin-bottom: 0.2rem;

            .p2 {
               font-size: 0.16rem;
               font-family: SourceHanSansSC-regular;
               margin-right: 0.1rem;
            }

            .div3 {
               .div3T {
                  display: flex;
                  justify-content: space-between;
                  color: rgba(107, 119, 133, 1);
                  font-size: 0.16rem;
                  font-family: SourceHanSansSC-regular;
               }
            }
         }
      }
   }

   .right {
      width: 45%;
      flex: 1;
      background-color: #F9FCFD;
      .imgs {
            width: 5.4rem;
      }
      .rightTop {
         padding: 0.25rem 0;
         background-color: #F3F9FB;
         margin-bottom: 0.5rem;
         .div1 {
            text-align: center;
            margin-bottom: 0.25rem;
            color: #000;
            font-size: 0.2rem;
            font-family: SourceHanSansSC-regular;
            position: relative;

            p {
               position: absolute;
               color: rgba(80, 85, 89, 0.68);
               font-size: 0.12rem;
               font-family: SourceHanSansSC-regular;
               right: 100px;
               top: 3px;
            }
         }
         .div2 {
            display: flex;
            align-items: center;
            justify-content: center;
         }
        
      }
   }
}
</style>